import { toast } from "react-toastify";
import { store } from "../Redux/store";
import { useTranslation } from "react-i18next";

import i18next from "i18next";
import { useSelector } from "react-redux";

export const checkPermission = (moduleName, isGinne, showToast = true) => {

    // console.log("checkPermission called with:", { moduleName, isGinne, showToast });




    if (!moduleName) return false;

    const normalized = moduleName.toLowerCase().trim();
    const state = store.getState();
    const permissions = state?.permissionsReducer?.permissions || {};
    // const allStores = state?.storeReducer?.selectedStore?.is_select_all_store || false;

    // console.log("KAKAKAKAKAK",allStores,);
    


    // if (allStores) {
    //     return true;
    // }

    // 1. Exact match by key
    let modulePermission = permissions[normalized];

    // 2. Fallback: match by name ignoring routes
    if (!modulePermission) {
        const key = Object.keys(permissions).find(
            (k) => k.toLowerCase() === normalized
        );
        if (key) modulePermission = permissions[key];
    }


    // 3. Permission not found
    if (!modulePermission) {
        if (showToast) toast.error("Permission not found");
        return false;
    }

    if (isGinne) {
        if (showToast) toast.error(i18next.t("You do not have permission to perform this action."));
        return false;
    }


    // 4. If user can only read, block any “edit/export/import” actions
    // Here you don’t need to send action, we just check edit permission
    if (!modulePermission.edit) {
        if (showToast) toast.error(i18next.t("You do not have permission to perform this action."));
        return false;
    }

    // 5. Allowed
    return true;
};
